// extracted by css-extract-rspack-plugin
export default {"banderole":"BanderoleInfo_banderole__dc4W8","banderoleContainer":"BanderoleInfo_banderoleContainer__hZhyS"};